function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        vector-effect: none-scaling-stroke;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 16.25,
  cy: 16.25,
  r: 15.75
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 22.14,
  y1: 10.36,
  x2: 10.36,
  y2: 22.14
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-1",
  x1: 22.14,
  y1: 22.14,
  x2: 10.36,
  y2: 10.36
}));

function SvgIconsClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVG_Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.5,
    height: 32.5,
    viewBox: "0 0 32.5 32.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsClose);
export default __webpack_public_path__ + "static/media/Icons_Close.573e2da3.svg";
export { ForwardRef as ReactComponent };